module.exports = __webpack_public_path__ + "static/media/APPLE.9b2cbea3.svg";